import React from "react";

const ACTIVE_STYLE = {
    backgroundColor: "#e7f1ff",
    color: "#0d6efd",
    border: "1px solid #b6d4fe",
};

const INACTIVE_STYLE = {
    backgroundColor: "#fff",
    color: "#6c757d",
    border: "1px solid #dee2e6",
};

const ICON_STYLE = {
    fontSize: "0.9rem",
    lineHeight: 1,
    display: "inline-block",
};

export function DisplayTogglePill({ icon, label, active, onClick }) {
    return (
        <button
            type="button"
            onClick={onClick}
            aria-pressed={active}
            className="d-inline-flex align-items-center"
            style={{
                ...(active ? ACTIVE_STYLE : INACTIVE_STYLE),
                gap: "6px",
                padding: "4px 12px",
                borderRadius: "20px",
                fontSize: "0.82rem",
                fontWeight: 500,
                lineHeight: 1,
                cursor: "pointer",
                transition: "all 0.15s ease",
            }}
        >
            {active && <i className="bi bi-check2" style={ICON_STYLE}></i>}
            {icon && <i className={`bi ${icon}`} style={ICON_STYLE}></i>}
            <span style={{ lineHeight: 1 }}>{label}</span>
        </button>
    );
}
